// reCAPTCHA の api.js を必要になった時点で1回だけ読み込む(SEO ジャンルページの問い合わせフォーム用)
// 読み込むきっかけ:
//   (a) フォーム(target)が画面に近づいた(IntersectionObserver。rootMargin ぶん手前で発火)
//   (b) ページ内の target へのリンク(href="#<target.id>")が押された
//   (c) フォーム内の入力欄にフォーカスした・フォームが送信された
// IntersectionObserver が無い環境では即時に読み込む。
// api.js の onload コールバック(window.recaptchaApiReady)はレイアウト側で api.js より前に定義しておくこと。
export function setupLazyRecaptcha({ target, src, doc = document, win = window, rootMargin = "600px 0px" } = {}) {
  if (!target || !src) return null

  let loaded = false
  let observer = null
  const anchorHref = target.id ? `#${target.id}` : null

  const onClick = (event) => {
    if (!anchorHref) return
    const node = event.target
    const link = node && typeof node.closest === "function" ? node.closest("a[href]") : null
    if (link && link.getAttribute("href") === anchorHref) load()
  }

  const removeListeners = () => {
    if (observer) observer.disconnect()
    doc.removeEventListener("click", onClick, true)
    target.removeEventListener("focusin", load)
    target.removeEventListener("submit", load, true)
  }

  function load() {
    if (loaded) return
    loaded = true
    removeListeners()

    // 既に読み込み済み(別経路で api.js が入っている)なら二重に挿入しない
    if (typeof win.grecaptcha !== "undefined") return
    const existing = Array.from(doc.getElementsByTagName("script")).some((script) => script.getAttribute("src") === src)
    if (existing) return

    const script = doc.createElement("script")
    script.src = src
    script.async = true
    script.defer = true
    doc.head.appendChild(script)
  }

  if (typeof win.IntersectionObserver !== "function") {
    load()
    return { load }
  }

  observer = new win.IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) load()
  }, { rootMargin })
  observer.observe(target)

  doc.addEventListener("click", onClick, true)
  target.addEventListener("focusin", load)
  target.addEventListener("submit", load, true)

  return { load }
}
